<script setup lang="ts">
import { useMeta } from '@/composables/useMeta';

useMeta(window.defaultMeta);
</script>

<template>
  <RouterView v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </RouterView>
</template>
